module.exports = __webpack_public_path__ + "img/img14.3bfcd57d.svg";